export const routerPaths = {
  root: '/',
  login: '/login',
  callCenter: '/dashboard/call-center',
  analytics: '/dashboard/analytics',
};
